import { createBrowserRouter } from "react-router";
import App from "../App";
import AdminAuth from "../components/AdminPortal/AdminAuth";
import { AdminPortal, AdminAuthProvider } from "../components/AdminPortal";
import AdminRoleGuard from "../components/AdminPortal/AdminRoleGuard";
import OauthRedirect from "../components/AdminPortal/SalesforceConnection/OauthRedirect"

const getSubdomain = () => {
  const host = window.location.hostname;
  const parts = host.split('.');
  return parts.length >= 2 ? parts[0] : null;
};

const subdomain = getSubdomain();

const isAdmin = subdomain === 'admin';

console.log("Current subdomain:", subdomain, "Is admin:", isAdmin);

export const router = createBrowserRouter([
  {
    path: "/",
    children: isAdmin
      ? [
          {
            element: (
              <AdminAuthProvider>
                <AdminAuth />
              </AdminAuthProvider>
            ),
            children: [
              {
                index: true,
                element: (
                  <AdminRoleGuard allowedRoles={["Admin"]}>
                    <AdminPortal />
                  </AdminRoleGuard>
                ),
              },
              {
                path: "OauthRedirect",
                element: (
                  <AdminRoleGuard allowedRoles={["Admin"]}>
                    <OauthRedirect />
                  </AdminRoleGuard>
                ),
              },
            ],
          },
        ]
      : [
          { index: true, element: <App /> },
        ],
  },
]);
